import { CommonModule } from '@angular/common';
import { Component, forwardRef, Input, OnInit, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, NgModel } from '@angular/forms';

@Component({
  selector: 'email-input',
  templateUrl: './email-input.component.html',
  styleUrls: ['./email-input.component.scss'],
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EmailInputComponent),
      multi: true,
    },
  ],
  imports: [
    CommonModule,
    FormsModule,
  ],
})
export class EmailInputComponent implements OnInit, ControlValueAccessor {
  emails: string[] = [];
  email: string = '';
  @Input() isEmailInvalid: boolean;
  @ViewChild('emailField') emailField!: NgModel;
  private onChangeCallback: (_: any) => void = () => { };
  private onTouchedCallback: () => void = () => { };
  disabled = false;

  constructor() {

  }
  writeValue(obj: any): void {
    this.updateValue();
  }
  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  private updateValue() {
    this.onChangeCallback(this.emails);
  }

  ngOnInit(): void {

  }
  addEmail() {
    const email = this.email?.replace(',', '');
    if (email && this.validateEmail(email)) {
      this.emails.push(email);
      this.email = '';
      this.emailField.reset();
      this.updateValue();
    }
  }

  onKeyUp(event: any) {
    const key = event.key;

    // Call addEmail when a comma is typed
    if (key === ',') {
      this.addEmail();
    }
  }


  removeEmail(index: number) {
    this.emails.splice(index, 1);
  }

  validateEmail(email: string): boolean {
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    return emailPattern.test(email);
  }
}
